import { type FeedbackDetailResponse } from '../../types/feedback';

export const FeedbackConversation = ({
  messages,
}: {
  messages: FeedbackDetailResponse['conversationMessages'];
}) => {
  if (messages.length === 0) return null;

  return (
    <div className="rounded-xl border border-black/10 bg-white p-6">
      <h3 className="text-sm font-semibold text-brand-blue mb-3">Konversationskontext</h3>
      <div className="space-y-2">
        {messages.map((message, index) => (
          <div
            key={index}
            className={`rounded-sm border px-4 py-2 text-sm ${
              message.role === 'user'
                ? 'border-brand-blue/20 bg-brand-blue/5'
                : 'border-black/10 bg-white'
            }`}
          >
            <p className="text-[11px] font-semibold uppercase tracking-wide text-text-grey mb-1">
              {message.role === 'user' ? 'Användare' : 'Assistant'}
              <span className="ml-2 font-normal normal-case text-text-grey/60">
                {new Date(message.createdAt).toLocaleString('sv-SE')}
              </span>
            </p>
            <p className="text-brand-blue whitespace-pre-wrap">{message.content}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
